import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ProcessModule, StateConfig, StateTransferType, provideDefaultConfigFactory } from '@spartacus/core';
import { reducerProvider, reducerToken } from './reducers';
import { UserAuthCookieDumpService } from './user-auth-cookie-dump.service';
import { UserPersistenceService } from './user-persistence.service';
import { CUSTOM_USER_FEATURE } from './user-state';

function customUserStoreConfigFactory(): StateConfig {
  // if we want to reuse CUSTOM_USER_FEATURE const in config, we have to use factory instead of plain object
  return {
    state: {
      ssrTransfer: {
        keys: { [CUSTOM_USER_FEATURE]: StateTransferType.TRANSFER_STATE },
      },
    },
  };
}

export function userStatePersistenceFactory(userPersistenceService: UserPersistenceService): () => void {
  return () => userPersistenceService.sync();
}

export function userAuthCookieDumpFactory(userAuthCookieDumpService: UserAuthCookieDumpService): () => void {
  return () => userAuthCookieDumpService.sync();
}

@NgModule({
  imports: [ProcessModule.forRoot(), StoreModule.forFeature(CUSTOM_USER_FEATURE, reducerToken)],
  providers: [
    provideDefaultConfigFactory(customUserStoreConfigFactory),
    reducerProvider,
    provideAppInitializer(() => {
      const initializerFn = userStatePersistenceFactory(inject(UserPersistenceService));

      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = userAuthCookieDumpFactory(inject(UserAuthCookieDumpService));

      return initializerFn();
    }),
  ],
})
export class UserStoreModule {}
